import React from 'react';
import { Filter as FilterAdmin, SelectInput, TextInput } from 'react-admin';

export const choicesAcao = [
  { id: 'assinar', name: 'Assinar' },
  { id: 'visualizar', name: 'Visualizar' },
  { id: 'enviar_arquivo', name: 'Enviar arquivo' },
];

export const choicesOrigem = [
  { id: 'upload', name: 'PDF enviado' },
  { id: 'texto', name: 'Texto com variáveis' },
  { id: 'por_colaborador', name: 'Um arquivo por colaborador' },
];

export const choicesRecorrencia = [
  { id: 'unica', name: 'Única' },
  { id: 'sob_demanda', name: 'Sob demanda' },
  { id: 'mensal', name: 'Mensal' },
  { id: 'anual', name: 'Anual' },
];

export const choicesQuemAssina = [
  { id: 'colaborador', name: 'Colaborador' },
  { id: 'usuario_fixo', name: 'Pessoa fixa' },
];

export const choicesAbrangencia = [
  { id: 'um', name: 'Um colaborador' },
  { id: 'varios', name: 'Vários colaboradores' },
  { id: 'todos', name: 'Todos os colaboradores' },
];

const Filter = (props) => (
  <FilterAdmin {...props}>
    <TextInput label="Nome" source="nome" />
    <SelectInput label="Ação" source="acao" choices={choicesAcao} />
    <SelectInput
      label="Tipo de documento"
      source="origem"
      choices={choicesOrigem}
    />
    <SelectInput
      label="Recorrência"
      source="recorrencia"
      choices={choicesRecorrencia}
    />
    <SelectInput
      label="Quem assina"
      source="quem_assina"
      choices={choicesQuemAssina}
    />
    <SelectInput
      label="Abrangência"
      source="abrangencia"
      choices={choicesAbrangencia}
    />
  </FilterAdmin>
);

export default Filter;
